export default __webpack_public_path__ + "static/media/bike-front-face.a4f6be03.jpg";